/**
 * Pixa rapor alanlarının Türkçe karşılıkları ve biçimlendirme kuralları.
 *
 * Pixa raporları ham camelCase anahtarlar döndürüyor (activeProducts,
 * duplicateBarcodeCountProducts…). Ekranda bunları büyük harfe çevirip göstermek
 * okunaksızdı; burada hem etiket hem de değerin nasıl biçimleneceği tanımlı.
 */

export const FIELD_TR: Record<string, string> = {
  // Ürün değişiklik geçmişi alanları
  fullDescription: 'Uzun açıklama', shortDescription: 'Kısa açıklama', deletionDate: 'Silinme tarihi',
  deleted: 'Silindi', draft: 'Taslak', isActive: 'Aktiflik', stockUpdatedOn: 'Stok güncelleme zamanı',
  // Temel sayılar
  activeProducts: 'Aktif ürün',
  activeProductCount: 'Aktif ürün',
  combinations: 'Varyant',
  duplicateBarcodeCountProducts: 'Mükerrer barkodlu ürün',
  duplicateBarcodeCountVariants: 'Mükerrer barkodlu varyant',
  categoryCount: 'Kategori',
  soldProductCount: 'Satılan ürün çeşidi',
  soldQuantity: 'Satılan adet',

  // Bugün
  todayOrders: 'Bugünkü sipariş',
  todayReadyOrders: 'Bugün hazırlanan',
  lastDayOrders: 'Dünkü sipariş',
  lastDayReadyOrders: 'Dün hazırlanan',

  // Satış
  totalRevenue: 'Toplam ciro',
  grossRevenue: 'Brüt ciro',
  netRevenue: 'Net ciro',
  productRevenue: 'Ürün cirosu',
  totalOrders: 'Toplam sipariş',
  orderCount: 'Sipariş',
  totalOrderCount: 'Toplam sipariş',
  dailyAverageOrders: 'Günlük ortalama sipariş',
  avgBasket: 'Ortalama sepet',
  avgProductPrice: 'Ortalama ürün fiyatı',
  totalQuantity: 'Toplam adet',
  quantity: 'Adet',
  generalTotal: 'Tutar',

  // Maliyet / kâr
  productCost: 'Ürün maliyeti',
  shippingCost: 'Kargo maliyeti',
  commissionCost: 'Komisyon',
  totalCost: 'Toplam maliyet',
  grossProfit: 'Brüt kâr',
  netProfit: 'Net kâr',
  profitMargin: 'Kâr marjı',
  netProfitMargin: 'Net kâr marjı',
  marketplaceSettlement: 'Net tutar (tüm kanallar)',
  costToRevenueRate: 'Maliyet/ciro oranı',
  productCostRate: 'Ürün maliyet oranı',

  // İade / iptal
  returnCancelLoss: 'İade + iptal kaybı',
  returnedRevenue: 'İade edilen ciro',
  cancelledRevenue: 'İptal edilen ciro',
  totalLoss: 'Toplam kayıp',
  cancelledOrderCount: 'İptal edilen sipariş',
  returnedLineCount: 'İade edilen satır',
  cancelRate: 'İptal oranı',
  returnRate: 'İade oranı',
  returnedQuantity: 'İade adedi',
  cancelledQuantity: 'İptal adedi',
  returnLineCount: 'İade satırı',
  lostGrossProfit: 'Kaybedilen brüt kâr',
  totalReturnDamage: 'Toplam iade zararı',
  totalCancellationDamage: 'Toplam iptal zararı',
  totalReturnedRevenue: 'İade edilen ciro',
  totalCancelledRevenue: 'İptal edilen ciro',
  totalReturnedQuantity: 'İade adedi',
  totalCancelledQuantity: 'İptal adedi',
  returnProductCount: 'İade edilen ürün çeşidi',
  cancelProductCount: 'İptal edilen ürün çeşidi',
  returnedProductCost: 'İade ürün maliyeti',
  returnedCommissionCost: 'İade komisyonu',
  returnedShippingCost: 'İade kargo maliyeti',
  cancelledProductCost: 'İptal ürün maliyeti',
  cancelledCommissionCost: 'İptal komisyonu',
  cancelledShippingCost: 'İptal kargo maliyeti',
  preventedCost: 'Önlenen maliyet',

  // Sipariş durumu tablosu
  status: 'Durum',
  prepared: 'Hazırlandı',
  invoiced: 'Faturalandı',
  eInvoiced: 'e-Fatura kesildi',
  shipped: 'Kargolandı',
  delivered: 'Teslim edildi',
  total: 'Toplam',
  returnStatus: 'İade durumu',
  orderId: 'Sipariş',

  // Pano detayları
  avgOrderValue: 'Ortalama sipariş tutarı',
  avgPrice: 'Ortalama fiyat',
  avgUnitProfit: 'Birim başı kâr',
  avgDailySales: 'Günlük ortalama satış',
  availableStock: 'Kullanılabilir stok',
  estimatedStockDays: 'Tahmini stok günü',
  commissionRate: 'Komisyon oranı',
  commissionShare: 'Komisyon payı',
  costCoverageRate: 'Maliyet girilme oranı',
  costFilledLineCount: 'Maliyeti girilmiş satır',
  costRate: 'Maliyet oranı',
  shippingRate: 'Kargo oranı',
  revenueShare: 'Ciro payı',
  revenueDelta: 'Ciro değişimi',
  changePercent: 'Değişim',
  share: 'Pay',
  percent: 'Yüzde',
  pressureIndex: 'Baskı endeksi',
  problemScore: 'Sorun puanı',
  riskLevel: 'Risk seviyesi',
  returnCancelLossRate: 'İade/iptal kayıp oranı',
  returnRequestCount: 'İade talebi',
  returnApprovedCount: 'Onaylanan iade',
  returnRejectedCount: 'Reddedilen iade',
  cancelCount: 'İptal sayısı',
  totalReturnReasonCount: 'İade nedeni sayısı',
  topReason: 'En sık neden',
  topReasonCount: 'En sık neden adedi',
  topReasonPercent: 'En sık neden oranı',
  mainReason: 'Ana neden',
  sampleReturnReason: 'Örnek iade nedeni',
  reason: 'Neden',
  reasons: 'Nedenler',
  premiumCount: 'Premium segment',
  premiumPercent: 'Premium oranı',
  midSegmentCount: 'Orta segment',
  midSegmentPercent: 'Orta segment oranı',
  economicCount: 'Ekonomik segment',
  economicPercent: 'Ekonomik oranı',
  totalLineCount: 'Toplam satır',
  totalCount: 'Toplam',
  hasCostData: 'Maliyet verisi var',
  opportunity: 'Fırsat',
  insight: 'Değerlendirme',
  impact: 'Etki',
  action: 'Aksiyon',
  hour: 'Saat',
  dayNo: 'Gün',
  period: 'Dönem',
  regionName: 'Bölge',
  platformName: 'Pazaryeri',
  productId: 'Ürün',
  combinationId: 'Varyant',
  resourceId: 'Kaynak',
  imageLink: 'Görsel',
  color: 'Renk',
  title: 'Başlık',
  label: 'Etiket',
  description: 'Açıklama',
  type: 'Tip',
  amount: 'Tutar',
  key: 'Anahtar',
  startDate: 'Başlangıç',
  endDate: 'Bitiş',
  creationDate: 'Oluşturulma',
  purchaseNumber: 'Sipariş no',
  invoiceNumber: 'Fatura no',
  eInvoiceNumber: 'e-Fatura no',
  erpId: 'ERP no',
  id: 'No',

  // Ortak
  platform: 'Pazaryeri',
  city: 'Şehir',
  date: 'Tarih',
  name: 'Ad',
  sku: 'SKU',
  barcode: 'Barkod',
  productName: 'Ürün',
  revenue: 'Ciro',
  cancelled: 'İptal',
  score: 'Puan',
  level: 'Seviye',
  summary: 'Özet',
  message: 'Mesaj',
  severity: 'Önem',
  cityName: 'Şehir',
  average: 'Ortalama',
  count: 'Adet',
  currency: 'Para birimi',
};

/** Grafik/dizi bölümlerinin başlıkları. */
export const SECTION_TR: Record<string, string> = {
  metrics: 'Özet Metrikler',
  charts: 'Detaylar',
  dailyRevenueTrend: 'Günlük ciro trendi',
  hourlyOrders: 'Saatlik sipariş dağılımı',
  weekdayOrders: 'Haftanın günlerine göre sipariş',
  topCities: 'En çok satış yapılan şehirler',
  returnsAndCancels: 'İade ve iptaller',
  returnsAndCancelsTrend: 'İade/iptal trendi',
  regionalSales: 'Bölgesel satış',
  returnCancelTrends: 'İade/iptal eğilimi',
  returnReasonAnalysis: 'İade nedenleri',
  regionalPriceSegments: 'Bölgesel fiyat segmentleri',
  topRevenueProducts: 'En çok ciro yapan ürünler',
  topSellingProducts: 'En çok satan ürünler',
  risingProducts: 'Yükselen ürünler',
  fallingProducts: 'Düşen ürünler',
  stockRiskProducts: 'Stok riski olan ürünler',
  profitAnalysis: 'Kâr analizi',
  productReturnRisk: 'İade riski yüksek ürünler',
  productCancelRisk: 'İptal riski yüksek ürünler',
  productLossSummary: 'Ürün kayıp özeti',
  productReturnReasons: 'Ürün bazlı iade nedenleri',
  problemProducts: 'Sorunlu ürünler',
  variantPerformance: 'Varyant performansı',
  financeHealth: 'Finansal sağlık',
  profitTrend: 'Kâr trendi',
  costBreakdown: 'Maliyet dağılımı',
  platformProfitability: 'Pazaryeri kârlılığı',
  productProfitability: 'Ürün kârlılığı',
  marginRiskProducts: 'Marj riski olan ürünler',
  lowMarginProducts: 'Düşük marjlı ürünler',
  highProfitProducts: 'Yüksek kârlı ürünler',
  commissionPressure: 'Komisyon baskısı',
  returnLossAnalysis: 'İade kaybı analizi',
  cancellationLossAnalysis: 'İptal kaybı analizi',
  profitOpportunities: 'Kâr fırsatları',
  addresses: 'Adresler',
  orders: 'Siparişler',
  platforms: 'Pazaryerleri',
  items: 'Kayıtlar',
  categories: 'Kategoriler',
  colors: 'Renkler',
  sizes: 'Bedenler',
  indicators: 'Göstergeler',
  warnings: 'Uyarılar',
  peakHour: 'En yoğun saat',
  bestDay: 'En iyi gün',
  worstDay: 'En zayıf gün',
  highestReturnProduct: 'En çok iade edilen ürün',
  highestCancelProduct: 'En çok iptal edilen ürün',
};

/** Ekranda gösterilmeyecek teknik alanlar. */
export const HIDDEN_KEYS = new Set(['filters', 'generatedAt', 'dateField', 'platformIds', 'calculateProfit', 'uuid']);

const MONEY_HINTS = ['revenue', 'cost', 'profit', 'price', 'basket', 'settlement', 'loss', 'damage', 'total'];
const PCT_HINTS = ['rate', 'margin', 'percent', 'pct'];
const NOT_MONEY = new Set(['totalQuantity', 'totalOrders', 'totalOrderCount', 'total',
  'totalReturnedQuantity', 'totalCancelledQuantity', 'cancelledOrderCount', 'returnProductCount',
  'cancelProductCount', 'returnLineCount', 'returnedLineCount']);

export type ValueKind = 'money' | 'pct' | 'count' | 'text';

export function valueKind(key: string, value: any): ValueKind {
  if (typeof value !== 'number' && isNaN(Number(value))) return 'text';
  const k = key.toLowerCase();
  if (PCT_HINTS.some(h => k.includes(h))) return 'pct';
  if (!NOT_MONEY.has(key) && MONEY_HINTS.some(h => k.includes(h))) return 'money';
  return 'count';
}

export function labelOf(key: string): string {
  return FIELD_TR[key] || SECTION_TR[key] || humanize(key);
}

export function sectionOf(key: string): string {
  return SECTION_TR[key] || FIELD_TR[key] || humanize(key);
}

/** Sözlükte olmayan anahtarlar için makul bir görünüm: camelCase → "Camel case". */
export function humanize(key: string): string {
  const s = String(key).replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/[_-]+/g, ' ').trim();
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

/** Başlıklarda her kelimenin ilk harfi büyük. 've', 'ile' gibi bağlaçlar küçük kalır. */
const LOWER_WORDS = new Set(['ve', 'ile', 'için', 'bazlı', 'göre']);
export function titleCase(s: string): string {
  return String(s || '').split(' ').map((w, i) => {
    if (!w) return w;
    if (i > 0 && LOWER_WORDS.has(w.toLocaleLowerCase('tr'))) return w.toLocaleLowerCase('tr');
    return w.charAt(0).toLocaleUpperCase('tr') + w.slice(1);
  }).join(' ');
}

/**
 * Pixa'nın döndürdüğü İngilizce kod değerlerinin Türkçesi.
 * (financeHealth.level='warning', warnings[].type='cost_data' gibi alanlar
 * ekranda İngilizce görünüyordu.)
 */
export const VALUE_TR: Record<string, string> = {
  // seviye / önem
  critical: 'Kritik', warning: 'Dikkat', danger: 'Riskli', good: 'İyi', healthy: 'Sağlıklı',
  excellent: 'Çok iyi', poor: 'Zayıf', stable: 'Dengeli', neutral: 'Nötr',
  high: 'Yüksek', medium: 'Orta', low: 'Düşük', none: 'Yok',
  // uyarı tipleri
  loss: 'Kayıp', cost_data: 'Maliyet verisi', margin: 'Marj', commission: 'Komisyon',
  cost: 'Maliyet', shipping: 'Kargo', stock: 'Stok', price: 'Fiyat', profit: 'Kâr',
  return: 'İade', cancel: 'İptal', returns: 'İadeler', cancels: 'İptaller',
  revenue: 'Ciro', opportunity: 'Fırsat', risk: 'Risk',
  // yön
  up: 'Artış', down: 'Düşüş', rising: 'Yükseliyor', falling: 'Düşüyor', flat: 'Sabit',
  increase: 'Artış', decrease: 'Azalış',
  // genel
  true: 'Evet', false: 'Hayır', yes: 'Evet', no: 'Hayır', unknown: 'Bilinmiyor',
};

export function translateValue(v: any): string {
  if (v === null || v === undefined) return '—';
  const s = String(v);
  return VALUE_TR[s] || VALUE_TR[s.toLowerCase()] || s;
}

/** İade durumu kodları — Pixa'nın enum sözlüğünde bu grup yok, kod olarak geliyor. */
export const RETURN_STATUS_TR: Record<string, string> = {
  '0': 'Talep yok', '1': 'İade talebi', '2': 'İade onaylandı',
  '3': 'İade reddedildi', '4': 'İade tamamlandı', '5': 'İptal edildi',
};

/** Tarih gibi görünen alanlar — ham ISO yerine biçimlenmiş gösterilir. */
export function isDateField(key: string, v: any): boolean {
  if (typeof v !== 'string') return false;
  if (!/^\d{4}-\d{2}-\d{2}/.test(v)) return false;
  return /date|time|at$/i.test(key) || v.includes('T');
}

/** Görsel alanları. */
export function isImageField(key: string, v: any): boolean {
  return typeof v === 'string' && /^https?:\/\//.test(v) && /image|img|photo|gorsel|link/i.test(key);
}
